<template>
   <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-date-picker 
                    v-model="jftime" 
                    type="daterange" 
                    range-separator="至" 
                    value-format="yyyy-MM-dd" 
                    start-placeholder="缴费开始日期"
                    end-placeholder="缴费结束日期"
                ></el-date-picker>
            </el-form-item>
            <el-form-item slot="title">
                <el-date-picker
                    v-model="kptime" 
                    type="daterange" 
                    range-separator="至" 
                    value-format="yyyy-MM-dd" 
                    start-placeholder="开票开始日期"
                    end-placeholder="开票结束日期"
                ></el-date-picker>
            </el-form-item>
            <template slot="btn">
                <el-button type="warning" icon="el-icon-download" @click="Export()">导出</el-button>
            </template>
        </my-search>
        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="订单编号" prop="orderscode" min-width="220"></el-table-column>
            <el-table-column label="部门" prop="adddeptname"  min-width="220"></el-table-column>     
            <el-table-column label="招标项目编号" prop="zbprocode" min-width="150"></el-table-column>
            <el-table-column label="招标项目名称" prop="zbproname" min-width="150"></el-table-column>   
            <el-table-column label="付款单位" prop="tbdwname"></el-table-column>
            <el-table-column label="付款金额" prop="orderssum">
                <template slot-scope="scope">
                    <div v-if="scope.row.orderssum">
                        {{scope.row.orderssum}}元
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="付款方式" prop="fkfs">
                <template slot-scope="scope">
                    <div v-if="scope.row.fkfs==='1'">
                        支付宝
                    </div>
                    <div v-else-if="scope.row.fkfs==='4'">
                        银联
                    </div>
                    <div v-else-if="scope.row.fkfs==='9'">
                        线下
                    </div>
                    <div v-else>

                    </div>
                </template>
            </el-table-column>
            <el-table-column label="缴费日期" prop="auditdate" width="99"></el-table-column>
            <el-table-column label="核实人" prop="auditusername"></el-table-column>
            <el-table-column label="是否开发票" prop="fpbj">
                <template slot-scope="scope">
                    <my-tag type="warning" v-if="scope.row.fpbj==='0'||scope.row.fpbj==='1'||scope.row.fpbj===null">
                        未开票
                    </my-tag>
                    <my-tag type="success" v-if="scope.row.fpbj==='2'">
                        已开票
                    </my-tag>
                </template>
            </el-table-column>
            <el-table-column label="开票时间" prop="fptime"></el-table-column>
            <el-table-column label="邮寄单号" prop="mailno">
            </el-table-column>
        </my-table>
        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/manage/finance/order/gkzb-gmbs/get_order_list.json`">
        </my-pagination>
   </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return {
            pgData: {
                sortname:'ordersdate', 
                sortorder:'desc',             
                txtKey:'',
                txtKey1:'',
                txtKey2:'',
                txtKey3:'',
                title:'',
            },
            tableData:[],
            exportData:[
                'No',
                '订单编号',
                '部门',
                '招标项目编号',
                '招标项目名称',
                '付款单位',
                '付款金额',
                '付款方式',
                '缴费日期',
                '核实人',
                '是否开发票',
                '开票时间',
                '邮寄单号',
            ],
            dwcode: '',
        }
    },
    computed: {
        jftime: {
            get() {
                return [this.pgData.txtKey, this.pgData.txtKey1]
            },
            set(val) {
                this.pgData.txtKey = val[0] || '';
                this.pgData.txtKey1 = val[1] || '';
            }
        },
        kptime: {
            get() {
                return [this.pgData.txtKey2, this.pgData.txtKey3]
            },
            set(val) {
                this.pgData.txtKey2 = val[0] || '';
                this.pgData.txtKey3 = val[1] || '';
            }
        }
    },
    methods: {
        // 导出文件
        Export:function(){
            var search = window.toSearch({
                txtKey: this.pgData.txtKey,
                txtKey1: this.pgData.txtKey1,
                txtKey2: this.pgData.txtKey2,
                txtKey3: this.pgData.txtKey3,
                sortname: this.pgData.sortname,
                sortorder: this.pgData.sortorder,
                title: encodeURIComponent(JSON.stringify(this.exportData))
            });

            window.location.href = this.getGetters('mngUrl') + '/manage/finance/order/gkzb-gmbs/export.json' + search;
        },
    },
    created() {

    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">

</style>
